import createIcon from '../../icons/createIcon';

const IconInformationCircleFilled = createIcon('IconInformationCircleFilled', '0 0 64 64', [
    [
        'path',
        {
            'fill-rule': 'evenodd',
            'clip-rule': 'evenodd',
            d: 'M56 32C56 45.2548 45.2548 56 32 56C18.7452 56 8 45.2548 8 32C8 18.7452 18.7452 8 32 8C45.2548 8 56 18.7452 56 32ZM10.2 28.1C10.2 28.1552 10.1552 28.2 10.1 28.2C10.0448 28.2 10 28.1552 10 28.1C10 28.0448 10.0448 28 10.1 28C10.1552 28 10.2 28.0448 10.2 28.1ZM29.8372 23.0357C30.4186 23.5833 31.1395 23.8571 32 23.8571C32.8605 23.8571 33.5698 23.5833 34.1279 23.0357C34.7093 22.4643 35 21.7619 35 20.9286C35 20.0952 34.7093 19.4048 34.1279 18.8571C33.5698 18.2857 32.8605 18 32 18C31.1395 18 30.4186 18.2857 29.8372 18.8571C29.2791 19.4048 29 20.0952 29 20.9286C29 21.7619 29.2791 22.4643 29.8372 23.0357ZM34.407 46V26.2143H29.5233V46H34.407Z',
            fill: '#191B21',
            key: 'd4451a'
        },
        []
    ]
]);

export { IconInformationCircleFilled };
